

export function calculateSavingsPercent(oldValue: number, newValue: number): number {
    if (oldValue === 0) {
        throw new Error("Old value cannot be zero");
    }

    const savings = ((oldValue - newValue) / oldValue) * 100;
    return savings;
}